var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoordsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 43,
    viewBox: "0 0 32 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.975 42.0338C22.25 36.628 32 23.5261 32 16.1668C32 7.2414 24.8333 0 16 0C7.1667 0 0 7.2414 0 16.1668C0 23.5261 9.75 36.628 14.025 42.0338C15.05 43.3221 16.95 43.3221 17.975 42.0338Z",
    fill: "#615C9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 10.7779C17.4148 10.7779 18.7713 11.3457 19.7715 12.3563C20.7717 13.3669 21.3336 14.7376 21.3336 16.1668C21.3336 17.5961 20.7717 18.9668 19.7715 19.9774C18.7713 20.988 17.4148 21.5558 16.0003 21.5558C14.5858 21.5558 13.2293 20.988 12.2291 19.9774C11.2289 18.9668 10.667 17.5961 10.667 16.1668C10.667 14.7376 11.2289 13.3669 12.2291 12.3563C13.2293 11.3457 14.5858 10.7779 16.0003 10.7779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordsIcon);
export default __webpack_public_path__ + "static/media/Coords_icon.31e84ef78028786c547e3875d0b07ec0.svg";
export { ForwardRef as ReactComponent };